import Api from '../api';

let resource = '/content';

export default {
  get(code: string, url: string) {
    if (!!window.location.search && window.location.search.length > 0) {
      resource += window.location.search;
    }
    return Api.post(`${resource}`, {
      code,
      url,
    });
  },
};
